import { observer } from 'mobx-react';
import * as React from 'react';
import { UncontrolledTooltip as TooltipStrap } from 'reactstrap';
import { IComponentProps } from '../../common';

export interface ITooltipProps extends IComponentProps {
    targetFactory: (props: IComponentProps) => React.ReactNode;
    placement?: Popper.Placement;
    autohide?: boolean;
    delay?: number | { show: number, hide: number };
    toggle?: () => void;
    isOpen?: boolean;
    targetid: string;
    allowOnTouchScreen?: boolean;
}

@observer
export class Tooltip extends React.Component<ITooltipProps, any> {
    private showTooltip: boolean;

    constructor(props: ITooltipProps) {
        super(props);
    }

    componentWillMount() {
        this.showTooltip = document.querySelector('.no-touchevents') ? true : false;
    }

    render() {
        const { targetFactory, allowOnTouchScreen, ...others } = this.props;
        return (<>
            {targetFactory({ id: this.props.targetid })}
            {
                (this.showTooltip || allowOnTouchScreen) &&
                <TooltipStrap
                    {...others}
                    delay={this.props.delay !== undefined ? this.props.delay : { show: 250, hide: 250 /* not to flicker when mouse goes through list */ }} /* although it should be default, hiding takes longer */
                    target={this.props.targetid}
                />
            }
        </>
        );
    }
}